import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Passavo ogni domenica sera a preparare gli allenamenti della settimana: esercizi, progressioni, riscaldamenti. Da quando uso GINNASTICA PRO™ scelgo un allenamento pronto, lo adatto al mio gruppo e in 15 minuti ho tutto. Ho recuperato le mie serate.',
  author: 'Giulia Ferrari',
  role: 'Allenatrice di Ginnastica Artistica, 29 anni'
}, {
  text: "Dirigo una società con oltre 120 atlete di livelli diversi ed era un incubo organizzare la stagione. I 'Programmi di Allenamento Progressivi' mi hanno permesso di strutturare tutto l'anno, dagli inizi fino ai saggi. Anche le mie assistenti ora lo usano.",
  author: 'Marco Bianchi',
  role: 'Responsabile Tecnico di Società, 44 anni'
}, {
  text: "Avevo sempre paura di bruciare le tappe con le principianti. La 'Libreria di Esercizi e Progressioni' spiega passo dopo passo come portare le atlete verso gli elementi più complessi in totale sicurezza. Le mie ginnaste migliorano molto più in fretta.",
  author: 'Chiara Rossi',
  role: 'Allenatrice Settore Base, 26 anni'
}, {
  text: "Le schede di valutazione e il 'Kit di Valutazione dell'Atleta' valgono da soli il prezzo del sistema. Tutto è professionale, chiaro e pronto da stampare. Mi sento molto più organizzata e credibile davanti alle atlete e alle famiglie.",
  author: 'Valentina Conti',
  role: 'Allenatrice Agonistica, 38 anni'
}, {
  text: "Con i piccolissimi facevo fatica a tenere alta l'attenzione. Grazie al 'Bonus Prevenzione Infortuni' e agli allenamenti Express da 30 minuti riesco a proporre sessioni sicure, dinamiche e sempre diverse. I genitori mi fanno i complimenti per l'organizzazione.",
  author: 'Alessia Moretti',
  role: 'Allenatrice Corsi Ricreativi, 33 anni'
}];
export function Testimonials() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-border" data-id="element-171">
      <div className="text-center mb-6" data-id="element-172">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-173">
          Cosa Dicono gli Allenatori
        </h2>
        <p className="text-sm sm:text-base font-heading font-bold text-brand-violet uppercase tracking-wide" data-id="element-174">
          Centinaia di allenatori risparmiano già ore ogni settimana
        </p>
      </div>

      <div className="flex flex-col gap-4" data-id="element-175">
        {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-border p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-176">
            <div className="flex gap-1 mb-3" data-id="element-177">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-178" />)}
            </div>
            <p className="text-brand-text font-medium mb-4 leading-relaxed italic text-sm sm:text-base" data-id="element-179">
              "{t.text}"
            </p>
            <div className="border-t border-brand-border pt-3 flex items-center gap-3" data-id="element-180">
              <div className="w-10 h-10 rounded-full bg-brand-violet/10 flex items-center justify-center text-brand-violet font-heading font-bold text-base border border-brand-violet/20" data-id="element-181">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-182">
                <p className="font-heading font-bold text-brand-navy text-sm" data-id="element-183">
                  {t.author}
                </p>
                <p className="text-[11px] sm:text-xs text-brand-muted font-bold uppercase tracking-wide mt-1" data-id="element-184">
                  {t.role}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}